/* 🤖 this file was generated by svg-to-ts */
export const matIconLineStyle: {
  name: 'line-style';
  data: string;
} = {
  name: 'line-style',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"/></svg>`
};
